import {
  type AriaAttributes,
  type DataHTMLAttributes,
  type FC,
  type PropsWithChildren,
} from 'react'

interface TSComponentProps {
  name: string
}

export const TSComponent: FC<
  AriaAttributes &
    DataHTMLAttributes<HTMLDivElement> &
    PropsWithChildren<TSComponentProps>
> = ({ name, children, ...rest }) => {
  return (
    <div {...rest}>
      <h1>name: {name}</h1>

      <hr />
      {children}
    </div>
  )
}
